import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { Button } from '../Button';
import { SectionTitle } from '../Section';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 90px;
  padding-left: 240px;
  max-width: 1000px;
  margin: auto;
  ${mediaQuery('tablet')} {
    padding-top: 0;
    padding-left: 0;
  }
`;

export const BackgroundCard = styled.div`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  background: ${(props) => props.theme.color.blue.default};
  width: 300px;
  height: 300px;
  left: 0;
  top: 0;
  position: absolute;
  ${mediaQuery('medium')} {
    padding-left: 60px;
  }
  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
`;

export const ContentCard = styled.div`
  text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  padding: 30px;
  text-align: left;
  ${mediaQuery('small')} {
    text-align: center;
    padding: 0px;
    box-shadow: none;
    background: transparent;
  }
`;

export const ContentCardTitle = styled(SectionTitle)``;

export const ContentCardButton = styled(Button)`
  margin-top: 30px;
`;
